export enum SeoEvent {
  SET_VENUE_PATHNAME = 'TL_SEO_SET_VENUE_PATHNAME',
  SET_EVENT_PATHNAME = 'TL_SEO_SET_EVENT_PATHNAME',
  RECACHE_VENUE = 'TL_SEO_RECACHE_VENUE',
  RECACHE_EVENT = 'TL_SEO_RECACHE_EVENT',
}
